import React from 'react';
import { roles } from '../data/mock';
import RoleCard from './RoleCard';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const RolesSection = () => {
  return (
    <section className="py-10 px-8 bg-white">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900">Featured Roles</h2>
        <Link to="/roles" className="flex items-center gap-1 text-indigo-600 text-sm font-medium hover:text-indigo-700 transition-colors">
          View all roles
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      
      {/* Scrollable Container */}
      <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
        {roles.slice(0, 6).map((role) => (
          <RoleCard key={role.id} role={role} />
        ))}
      </div>
    </section>
  );
};

export default RolesSection;
